import { render, staticRenderFns } from "./IncomeTopSlot.vue?vue&type=template&id=0a5a67dd"
import script from "./IncomeTopSlot.vue?vue&type=script&lang=js"
export * from "./IncomeTopSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports